import { PluginDefinition } from '@/types/plugin'

import { CatalogueFeedPlugin } from './catalogue-feed'

export const PLUGIN_REGISTRY: PluginDefinition[] = [CatalogueFeedPlugin]
